import { useState } from 'react'

/**
 * The time of day something is logged at, typed to the minute. It is one field, sitting under
 * the calendar that chose the day, and it is the browser's own time control: whatever a
 * browser gives a person for typing a time — a keypad on a phone, two spinners on a desktop —
 * is better at it than a pair of columns we could scroll for them, and those columns only ever
 * offered every fifth minute anyway, so the field beside them was where an exact time was
 * really typed. Now it is the whole of it.
 */
export function TimePicker({ value, onValue }: { value: string; onValue: (next: string) => void }) {
  /** What the field holds, which is the time once it reads as one — see below. */
  const [typed, setTyped] = useState(value)
  const [followed, setFollowed] = useState(value)
  if (followed !== value) {
    setFollowed(value)
    setTyped(value)
  }
  return (
    <input
      type="time"
      aria-label="Time"
      value={typed}
      onChange={(event) => {
        // Everything typed is kept, so a time is typed a digit at a time; only what reads as
        // a time is taken.
        setTyped(event.target.value)
        if (/^\d{2}:\d{2}$/.test(event.target.value)) {
          onValue(event.target.value)
        }
      }}
      className="w-full rounded-2xl bg-surface px-4 py-3 text-center text-2xl tabular-nums outline-none ring-1 ring-white/10 focus:ring-2 focus:ring-accent"
    />
  )
}
